var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "sub-values inline" }, [
        _c("div", { staticClass: "sub-value" }, [
          _c(
            "div",
            {
              staticClass: "label clickable",
              on: {
                click: function($event) {
                  return _vm.$emit("click")
                }
              }
            },
            [
              _vm.type === "immediately"
                ? [_vm._v("Ab sofort")]
                : _vm.date
                ? [
                    _vm._v(
                      "Ab " + _vm._s(_vm._f("dateByObject")(_vm.data.date))
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }